@if(loaderService.loaderVisible$ | async){
    <div class="overlay-container">
    
        <div class="inprogress">
            <div class="inprogress-text" [innerHtml]="loaderService.loaderText$ | async | safeHtmlPipe"></div>
    
            <div class="inprogress-bar">
    
                @let loaderProgress = (loaderService.loaderProgress$ | async) ?? 0;
    
                @if(loaderProgress > 0){
                    <mat-progress-bar mode="determinate" [value]="loaderProgress"></mat-progress-bar>
                }
        
                @if(loaderProgress === 0){
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                }
    
            </div>
    
            <div class="inprogress-close">
                <button mat-mini-fab color="primary" (click)="onClose($event)">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
    
        </div>
        
    </div>
}
